import { IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";

export class ApplyForLeavesRequest{

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    applyForLeavesId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;

    @ApiProperty()
    status?: LeaveApprovalStatusEnum;

    @ApiProperty()
    rejectionReason?:string;
}